import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Actions from '../../../../actions'
import Operations from '../../../../operations'
import { connect } from 'react-redux'
import { showToast } from '../../../../common/utils'
import { ShiftPasswordsList } from './components'
import { Spinner } from '../../../../components/generic'
import { sizes } from '@lmc/common/constants'
import Glyph from '../../../../LEGACY/Glyph'
import { ButtonOLD, EmptyState, NoDataIcon, PageHeader } from '@lmc/ui-kit'
import { PreferencesBanner } from '../DeviceAccessScreen/components/PreferencesBanner'
import {
  NO_SHIFTS_DESC,
  NO_SHIFTS_MESSAGE,
  SUPPORT_LINK,
} from './components/constants'

export class ShiftPasswordsScreen extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    deleteDialogOpen: false,
  }

  componentDidMount() {
    if (this.props.home.features?.shifts?.enabled) {
      this.props.fetchShifts()
    }
  }

  handleDelete = (id) => {
    this.props.deleteShift(id)
    showToast({ type: 'info', title: 'Deleted a Shift' })
  }

  render() {
    const { shifts, deleteShift, openModal, home } = this.props

    const hasShiftsEnabled = home.features?.shifts?.enabled

    const isLoading = shifts === undefined

    const hasShifts = !!shifts?.length

    return (
      <div style={styles.mainContainer}>
        <PageHeader title="Shift Passwords">
          <ButtonOLD
            onClick={openModal}
            style={styles.addButton}
            type="primary"
            icon={<Glyph name="plus" />}
            disabled={!hasShiftsEnabled}
          >
            Add a Shift Password
          </ButtonOLD>
        </PageHeader>
        {!hasShiftsEnabled && (
          <PreferencesBanner title="You haven’t enabled Shift Passwords in " />
        )}
        <div style={styles.innerWrapper} />
        {hasShiftsEnabled && !isLoading && hasShifts && (
          <ShiftPasswordsList shifts={shifts} onDelete={deleteShift} />
        )}
        {hasShiftsEnabled && isLoading && <Spinner />}
        {(!hasShifts || !hasShiftsEnabled) && (
          <EmptyState
            title={NO_SHIFTS_MESSAGE}
            description={NO_SHIFTS_DESC}
            icon={<NoDataIcon />}
          >
            <a href={SUPPORT_LINK} rel="noreferrer" target="_blank">
              Find out more
            </a>
          </EmptyState>
        )}
      </div>
    )
  }
}

const styles = {
  addButton: {
    float: 'right',
  },
  mainContainer: {
    padding: '24px',
    overflow: 'auto',
    height: '83vh',
    margin: '0 auto',
    width: '100%',
    maxWidth: sizes.childScreen,
    wordWrap: 'break-word',
  },
  innerWrapper: {
    marginTop: 24,
  },
}

ShiftPasswordsScreen.propTypes = {
  shifts: PropTypes.array,
  home: PropTypes.object,
}

const mapStateToProps = (state) => ({
  shifts: state.data.shifts,
  home: state.global.home,
})

const mapDispatchToProps = (dispatch) => ({
  fetchShifts: () => dispatch(Operations.loadList('shifts')),
  deleteShift: (id) => dispatch(Operations.deleteShift(id)),
  openModal: () => {
    const id = 'addShift'
    dispatch(Actions.openModal({ modalId: id }))
    dispatch(Actions.addForm({ formId: id }))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShiftPasswordsScreen)
